// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__1mqip","list":"FieldCheckboxGroup_list__3UBNv","twoColumns":"FieldCheckboxGroup_twoColumns__IA5oN","item":"FieldCheckboxGroup_item__c5FNI"};